export const REACT_APP_INSTAGRAM_ACCESS_TOKEN="IGAGXpGgs3s6ZABZAGI1dFNrblB6SGRNclJuc2xWdFJPRFJvekNFNDV1Tm8wUzNNY2VpRDQ2VnByU2hKSEdvNmpQYnpBWGhxTDJ2aVg2UWUtOXBqTUpsLXpxV0JqcU4yeFRVRGs5Mkh4clF1UFdVa05vUGhISkhDZAElRcGdOMDJ2MAZDZD"

export const REACT_APP_API_URL=process.env.REACT_APP_API_URL || "http://localhost:5000";

